<template>
  <div v-if="identityData?.length" class="flex flex-col">
    <div class="mb-4">
      <fraud-entries-dropdown
        class="max-w-max"
        :options="identityOptions"
        :value="selectedIdentity"
        placeholder="identities found"
        @change="handleIdentityChange"
      />
    </div>
    <template
      v-for="(field, fieldName) in identityData[selectedIdentity - 1]?.fields ||
      []"
      :key="fieldName"
    >
      <fraud-list-item
        :field-name="fieldName?.toString()"
        :field-data="field"
        :identity="identityData[selectedIdentity - 1]?.identity"
      />
    </template>
  </div>
  <div v-else class="flex items-center justify-center">
    No identities found.
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";

import groupBy from "lodash/groupBy";

import FraudEntriesDropdown from "./FraudEntriesDropdown.vue";
import FraudListItem from "./FraudListItem.vue";

import type { Data } from "@/models/commercialData/Sentilink";
import type { PropType } from "vue";

export default defineComponent({
  components: {
    FraudListItem,
    FraudEntriesDropdown,
  },
  props: {
    data: {
      type: Object as PropType<Data>,
      required: true,
    },
  },
  setup(props) {
    const selectedIdentity = ref(1);

    const identityData = computed(() =>
      Object.values(props.data?.identities || {}).map((idt) => {
        const fields = groupBy(idt?.match_info?.match_details || {}, "field");
        return {
          ...idt,
          fields,
        };
      })
    );

    const identityOptions = computed(() =>
      identityData.value.reduce(
        // incrementing just to make the entry list user-friendly
        (acc, _, index) => ({ ...acc, [index + 1]: index + 1 }),
        {}
      )
    );

    const handleIdentityChange = (val: number) => {
      selectedIdentity.value = val;
    };

    return {
      identityData,
      selectedIdentity,
      handleIdentityChange,
      identityOptions,
    };
  },
});
</script>
